import { SpecialtyCtaType } from '@/lib/types';

import { SpecialtyPage } from '@/features/specialty-page';
import RegionsService, { Region } from '@/services/regions.service';

type SpecialtyCtasProps = {
  regions: Region[];
};

export type SpecialtyCtasMap = Record<string, SpecialtyCtasProps>;

const get = async (specialtyPage: SpecialtyPage): Promise<SpecialtyCtasMap> => {
  const specialtyCtasComponents = specialtyPage.components.filter(
    (c) =>
      c.__typename === 'SpecialtyCTA' &&
      c.specialtyCtaType === SpecialtyCtaType.SearchSpecialtyJobsByLocation
  );

  if (!specialtyCtasComponents) return {};

  const [regions] = await Promise.all([RegionsService.get()]);

  return Object.fromEntries(
    specialtyCtasComponents.map((c): [string, SpecialtyCtasProps] => {
      return [
        c.id,
        {
          regions,
        },
      ];
    })
  );
};

const SpecialtyCtasService = {
  get,
};

export default SpecialtyCtasService;
